import './datepicker';
import $ from 'jquery';

$(function () {

    $('[data-toggle="datepicker"]').each(function () {

        var format = $(this).data('datepicker-format');
        if (!format) {
            format = 'yyyy-mm-dd';
        }

        var params = {
            format: format,
            inline: true
        };

        if ($(this).data('datepicker-present')) {
            params.startDate = new Date();
        }

        $(this).datepicker(params);
    });
});
